export default "__VITE_PUBLIC_ASSET__e3f3445f__"